<template>
    <div class="bank-title">
        <label>{{$t('add-your','Add Your')}} <span>{{$t('bank','Bank')}}</span> {{$t('account-details','Account Details')}}*</label>
    </div>
    <div class="back-modal hide-input-sec">
        <div class="number-sec1 row">
            <div class="number-header mt-0 col-12">
                <!-- <label>{{$t('bank-name','Bank Name')}}</label> -->
                <div class="search-sec">
                    <div class="flex-nowrap search-con" v-if="filteredBankList">
                        <div class="select-payment-list">
                            <div class="dropdown">
                                <button class="btn dropdown-toggle" type="button" @click="searchBank =  null" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                {{  selectedBank ? selectedBank : $t('select-bank-name', 'Select Bank Name') }}
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                    <div class="search-input">
                                        <input type="search" v-model="searchBank" class="form-control" placeholder="Search Banks...">
                                    </div>
                                    <li v-for="(item, index) in filteredBankList" :key="index" v-if="filteredBankList && filteredBankList.length">
                                        <a class="dropdown-item" @click="selectBank(item)" v-if=" item.bank_name ">{{ item.bank_name }}</a>
                                    </li>
                                    <li v-else>
                                        <a class="dropdown-item">No Data Found</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <span class="error-messages-text" v-if="v$.bankDetails.method_id.$error">{{$t('please-select-bank-account','Please select a bank')}}</span>
                    </div>
                </div>
            </div>

            <div class="number-header col-12">
                <label>{{$t('account-holder-name','Account holder’s name')}}* </label>
                <input v-model="bankDetails.account_holder_name" class="form-control profit-input" type="text" placeholder="Enter Account Holder Name" />
                <span class="error-messages-text" v-if="v$.bankDetails.account_holder_name.$error">
                    <template v-if="v$.bankDetails.account_holder_name.required.$invalid">
                        {{$t('please-enter-name','Account holder name is required.')}}
                    </template>
                    <template v-else-if="v$.bankDetails.account_holder_name.minLength.$invalid || v$.bankDetails.account_holder_name.maxLength.$invalid">
                        {{$t('min-characters','Account holder name must be 3-100 characters.')}}
                    </template>
                    <template v-if="v$.bankDetails.account_holder_name.alphaName.$invalid">
                        {{$t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.')}}
                    </template>
                </span>
            </div>

            <div class="number-header col-12">
                <label>{{$t('account-number','Account number')}}* </label>
                <input v-model="bankDetails.account_no" class="form-control profit-input" placeholder="Enter Account Number" />
                <span class="error-messages-text" v-if="v$.bankDetails.account_no.$error">
                    <template v-if="v$.bankDetails.account_no.required.$invalid">
                        {{$t('please-enter-account-number','Account number is required.')}}
                    </template>
                    <template v-else-if="v$.bankDetails.account_no.accountNoValidator.$invalid">
                        {{$t('invalid-account-number','Account number must be valid numeric value between 9 to 18 digits.')}}
                    </template>
                </span>
            </div>
            
            <div class="number-header col-12">
                <label>{{$t('ifsc-code','IFSC Code')}}* </label>
                <input v-model="bankDetails.ifsc_code" @input="bankDetails.ifsc_code = bankDetails.ifsc_code.toUpperCase()" class="form-control profit-input" type="text" placeholder="Enter IFSC Code" />
                <span class="error-messages-text" v-if="v$.bankDetails.ifsc_code.$error">
                    <template v-if="v$.bankDetails.ifsc_code.required.$invalid">
                        {{$t('please-enter-ifsc-code','IFSC Code Is Required')}}
                    </template>
                    <template v-else-if="v$.bankDetails.ifsc_code.ifscValidator.$invalid">
                        IFSC code should be 11 alphanumeric characters.
                    </template>
                </span>
            </div>

            <div v-if="!is2faEnabled" class="number-header">
                <label>{{$t('withDraw-password','Withdraw Password')}}* </label>
                <div class="password-field-rel">
                    <input v-model="bankDetails.withdrawal_password" :type="withdrawPasswordFieldType" class="form-control" placeholder="Enter Withdraw Password" />
                    <div class="showHide-icon" @click="togglePasswordVisibility('withdrawPassword')">
                        <i v-if="withdrawPasswordFieldType === 'password'" aria-hidden="true" class="fa fa-eye-slash"></i>
                        <i v-else aria-hidden="true" class="fa fa-eye"></i>
                    </div>
                </div>
                <span class="error-messages-text" v-if="v$.bankDetails.withdrawal_password.$error">{{$t('please-enter-withdraw-password','Please Enter Withdraw Password')}}</span>
            </div>
            <div v-else class="number-header">
                <label>{{$t('authentication-code','Authentication Code')}} * </label>
                <div class="password-field-rel">
                    <input v-model="bankDetails.otp" minlength="6" maxlength="6" class="form-control" placeholder="Enter Authentication Code "  @input="bankDetails.otp = $helper.sanitizeNumber(bankDetails.otp,999999);"/>
                </div>
                <span class="error-messages-text" v-if="v$.bankDetails.otp.$error">
                    <template v-if="v$.bankDetails.otp.required.$invalid">
                        {{ $t('authentication-code-required', 'Authentication Code is required') }}
                    </template>
                    <template v-else-if="v$.bankDetails.otp.minLength.$invalid || v$.bankDetails.otp.maxLength.$invalid">
                        {{ $t('authentication-code-6-digit', 'Authentication Code must be 6 digits') }}
                    </template>
                </span>            
            </div>
        </div>
    </div>
</template>

<script>
import { required, minLength, maxLength, helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core';
const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const accountNoValidator = helpers.withMessage(
  'Account number must be valid numeric value between 9 to 18 digits.',
  (value) => {
    if (!value) return true
    return /^[0-9]{9,18}$/.test(String(value))
  }
)
const ifscValidator = helpers.withMessage(
  "Invalid IFSC Code format. It should be 11 alphanumeric characters.",
  (value) => {
    if (!value) return true
    return /^[a-zA-Z0-9]{11}$/.test(String(value))
  }
)

export default {
    name: 'AddBankAccount',
    setup() {
		return { v$: useVuelidate() }
	},
    props:['bankDetails','is2faEnabled'],
    inject:['walletConfig'],
    emits:['forget-withdraw-password'],
    validations() {
        return{
            bankDetails: {
                method_id: { required },
                account_holder_name: {
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName
                },
                account_no: {
                    required,
                    accountNoValidator
                },
                ifsc_code: {
                    required,
                    ifscValidator
                },
                withdrawal_password: this.is2faEnabled ? {} : { required },
				otp: this.is2faEnabled ? {
					required,
					minLength: minLength(6),
					maxLength: maxLength(6)
				}:{}
            }
        }
    },
    data(){
        return{
            searchBank: '',
            selectedBank: null,
            withdrawPasswordFieldType : 'password',
        }
    },
    computed: {
        filteredBankList() {            
            if(this.searchBank) {
                const searchTermLower = this.searchBank?.toLowerCase();
                return this.walletConfig?.bank_list?.filter(item => item?.bank_name?.toLowerCase()?.includes(searchTermLower));
            }
            return this.walletConfig?.bank_list
        }
    },
    methods:{
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'withdrawPassword'){
                this.withdrawPasswordFieldType = this.withdrawPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        selectBank(item){
            this.bankDetails.method_id = item.id
            this.selectedBank = item.bank_name
        },
    }
}
</script>